import { PaymentMethodSettingsKeys } from '../constants';

import { FieldData } from './common';

export interface PaymentMethodSetting {
    paymentMethodId: number;
    role: string;
    [PaymentMethodSettingsKeys.DailyLimit]: string;
    [PaymentMethodSettingsKeys.UpToThresholdCommissionRate]: string;
    [PaymentMethodSettingsKeys.EqualOrAboveThresholdCommissionRate]: string;
    [PaymentMethodSettingsKeys.ThresholdOrderAmount]: string;
}

export interface PaymentMethodSettingsResponse {
    paymentMethodSettings: PaymentMethodSettingsResponseItem[];
}

export interface PaymentMethodSettingsResponseItem {
    paymentMethodId: number;
    roleSettings: PaymentMethodRoleSetting[];
}

export interface PaymentMethodRoleSetting {
    role: string;
    settings: FieldData[];
}

export interface UiPaymentMethodSettings {
    id: number;
    name: string;
    items: UiPaymentMethodSettingsItem[];
}

export type UiPaymentMethodSettingsItem = Omit<PaymentMethodSetting, 'paymentMethodId'>;
